export enum SearchFilterType {
  LIST = 'LIST',
  BUTTON = 'BUTTON',
}
